import { j as d } from "../../../../jsx-runtime-p91LotPX.mjs";
import { cleanArrayPredicate as R } from "../../../utils/predicate.js";
import { useState as C, useEffect as Z, useCallback as w, useMemo as V } from "react";
import { filterDefaultColsPredicate as $, filterPinnedColumns as v, getColIdsPredicate as O, mapColumnStateResetPredicate as ee, getSortColumns as te, mapFilterLockColsPredicate as k, filterActionColsDefsPredicate as F, mapColumnStatePredicate as re } from "../../predicate.js";
import { S as D } from "../../../../main-C3-4ZYQP.mjs";
import { C as ne } from "../../../../ColumnSearch-DyjTqam1.mjs";
import { TableSortListGroup as le } from "./ColumnSortList.js";
import { GrowFlex as G } from "../../../Flex/Flex.js";
function fe(p) {
  const {
    api: r,
    columnApi: s
  } = p, [m, f] = C(), [M, _] = C(), [P, U] = C(), [g, z] = C(), [I, H] = C(!1);
  function K() {
    var l, o, a, i;
    const e = (o = (l = r == null ? void 0 : r.getColumnDefs()) == null ? void 0 : l.map(k).filter(R)) == null ? void 0 : o.filter(F), t = (i = (a = p.defaultState) == null ? void 0 : a.map(k).filter(R)) == null ? void 0 : i.filter(F).flatMap(re), n = e == null ? void 0 : e.map((c, h) => {
      var y, E, L, T, N, A;
      const u = c;
      if ((E = (y = u.cellRendererParams) == null ? void 0 : y.columnCustom) != null && E.groupBy) {
        const X = (A = (N = (T = (L = u.cellRendererParams) == null ? void 0 : L.columnCustom) == null ? void 0 : T.groupBy) == null ? void 0 : N.column) == null ? void 0 : A.children.map((x) => {
          const B = e.find((Y) => Y.colId === x.colId);
          return B ? {
            ...B,
            ...x
          } : x;
        });
        return u.cellRendererParams.columnCustom.groupBy.omit ? null : {
          ...u.cellRendererParams.columnCustom.groupBy.column,
          children: X,
          id: h + 1
        };
      }
      return {
        ...c,
        id: h + 1
      };
    }).filter(Boolean);
    f(n), _(n), U(t);
  }
  Z(K, [r, s, p.defaultState]);
  function q(...e) {
    const [t] = e;
    f(t);
    const n = t.flatMap(O).filter(R);
    s && (s.moveColumns(n, p.sortIndex ?? 1), r == null || r.dispatchEvent({
      type: "columnMoved"
    }));
  }
  function J(e, t) {
    s && (s.setColumnsVisible(e, t), r == null || r.dispatchEvent({
      type: "columnVisible"
    }));
  }
  const b = w(J, [r, s]);
  function Q(e, t) {
    var l, o, a, i;
    const n = !!e.pinned || ((o = (l = e.cellRendererParams) == null ? void 0 : l.columnCustom) == null ? void 0 : o.type) === "NON_SORT" || ((i = (a = e.cellRendererParams) == null ? void 0 : a.columnCustom) == null ? void 0 : i.type) === "DEFAULT_NON_SORT";
    return /* @__PURE__ */ d.jsx(D.Item, { id: e.id, disabled: n, isOverlay: t, children: /* @__PURE__ */ d.jsxs(G, { align: "center", space: "4", justify: "space-between", style: {
      width: "100%"
    }, children: [
      /* @__PURE__ */ d.jsx(le, { isOverlay: t, list: e, expandedKeys: I ? [] : void 0, onChangeCheckCheckGroup: (c, h) => {
        if (e.children) {
          const u = e.children.map((y) => y.colId);
          b(c.length ? c : u, h);
        } else
          b(c.length ? c : [e == null ? void 0 : e.colId], h);
      } }),
      /* @__PURE__ */ d.jsx(D.DragHandle, { list: e, disabled: n })
    ] }) }, e.id);
  }
  const W = w(Q, [I, b]), S = V(() => [...m ?? []].filter($).filter(v).flatMap(O), [m]), j = V(() => g ? [...m ?? []].filter((e) => {
    var t;
    return e.children ? e.children.map((n) => {
      var l;
      return (l = n.headerName) == null ? void 0 : l.toLowerCase().includes(g.toLowerCase());
    }).includes(!0) : (t = e.headerName) == null ? void 0 : t.toLowerCase().includes(g.toLowerCase());
  }) : m, [m, g]);
  return /* @__PURE__ */ d.jsxs(G, { vertical: !0, space: "12", children: [
    /* @__PURE__ */ d.jsx(ne, { isOrderChange: !1, onSearch: (e) => {
      z(e.trim());
    }, onSelectAll: () => {
      s && (s.setColumnsVisible(S, !0), r == null || r.dispatchEvent({
        type: "columnVisible"
      }), f((e) => e == null ? void 0 : e.map((t) => t.children ? {
        ...t,
        children: t.children.map((n) => ({
          ...n,
          hide: !1
        }))
      } : {
        ...t,
        hide: !1
      })));
    }, onSelectNone: () => {
      s && (s.setColumnsVisible(S, !1), r == null || r.dispatchEvent({
        type: "columnVisible"
      }), f((e) => e == null ? void 0 : e.map((t) => {
        var o, a;
        const n = t.pinned, l = (a = (o = t.cellRendererParams) == null ? void 0 : o.columnCustom) == null ? void 0 : a.type;
        return n || l === "DEFAULT" || l === "DEFAULT_NON_SORT" ? t : t.children ? {
          ...t,
          children: t.children.map((i) => ({
            ...i,
            hide: !0
          }))
        } : {
          ...t,
          hide: !0
        };
      })));
    }, onReset: () => {
      if (!s)
        return;
      r == null || r.dispatchEvent({
        type: "columnVisible"
      });
      const e = P == null ? void 0 : P.map(ee), t = te(M, e == null ? void 0 : e.map((n) => n.colId));
      s.applyColumnState({
        state: e,
        applyOrder: !0
      }), f(t == null ? void 0 : t.map((n) => n.children ? {
        ...n,
        children: n.children.map((l) => ({
          ...l,
          hide: !1
        }))
      } : {
        ...n,
        hide: !1
      }));
    } }),
    /* @__PURE__ */ d.jsx(D, { items: j || [], onChange: q, renderItem: W, onDragging: (e) => {
      H(e);
    } })
  ] });
}
export {
  fe as default
};
//# sourceMappingURL=ColumnArea.js.map
